import React from 'react'
import { List, ListItem } from 'material-ui/List'
import Divider from 'material-ui/Divider'
import Subheader from 'material-ui/Subheader'
import Avatar from 'material-ui/Avatar'
import Paper from 'material-ui/Paper'

const SHOWED_ELEMENTS = 3

const style = {
  paper: {
    marginBottom: 10,
  },
  list: {
    overflow: 'scroll',
    maxHeight: (57 * SHOWED_ELEMENTS),
  },
}

const ProfileListItem = (item, toggleDialog, toggleOpen) => (
  <div key={item.id}>
    <Divider />
    <ListItem
      leftAvatar={<Avatar src={item.image_url} />}
      primaryText={item.name}
      secondaryText={item.text}
      onTouchTap={() => toggleDialog(item.id,toggleOpen)}
    />
  </div>
)

const ProfileList = ({ list_name, empty_message = "No has ganado ninguna", items, toggleDialog, toggleOpen }) => (
  <Paper zDepth={1} style={style.paper} >
    <List>
      <Subheader> {list_name} </Subheader>
      <Divider />
      <div style={style.list}>
        {items.length>0 ?
          items.map(item => ProfileListItem(item,toggleDialog,toggleOpen))
          :
        <div>
          <Divider />
          <ListItem
            primaryText={empty_message}/>
        </div>
          }
      </div>
    </List>
  </Paper>
)

// ProfileListItem.propTypes = {
//   item: React.PropTypes.shape({
//     id: React.PropTypes.number.isRequired,
//     name: React.PropTypes.string.isRequired,
//     text: React.PropTypes.string,
//   }).isRequired,
// }

// ProfileList.propTypes = {
//   list_name: React.PropTypes.string.isRequired,
//   items: React.PropTypes.arrayOf(
//     React.PropTypes.shape({
//       id: React.PropTypes.number.isRequired,
//       name: React.PropTypes.string.isRequired,
//       text: React.PropTypes.string,
//     })).isRequired,
// }

export default ProfileList



// WEBPACK FOOTER //
// ./src/components/Main/Profile/_List/index.jsx